export const MOCK_DELAY = 300;
